import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Input,
  TextArea,
  Form,
  Menu,
  Icon,
  Button,
  Loader,
  Header,
  Modal,
  Radio,
  Checkbox,
  Segment,
} from "semantic-ui-react";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as yup from "yup";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Informacoes from "../../../../components/Admin/Empresas/Criar/Informacoes";
import Planos from "../../../../components/Admin/Empresas/Criar/Planos";

import swal from "sweetalert";
import { isAuthAdmin } from "../../../../services/auth";
import {
  Container,
  Content,
  Title,
  Field,
  Label,
  InputFile,
  InputText,
  InputLabel,
  AlignDiv,
} from "./styled";

import { producaov2 as api } from "../../../../services/apis";

const CriarEmpresas = () => {
  const [valorName, setValorName] = useState("Informacoes");
  const [empresa, setEmpresa] = useState({
    nome: "",
    logo: "",
    url: "",
    file: "",
    id_pessoa: "48",
  });
  const [idEmpresa, setIdEmpresa] = useState("");
  const logo = useRef({ valor: "" });
  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/empresas`);
      window.location.href = "/login";
      return null;
    }
  };

  const uploadImage = async (imagem) => {
    setEmpresa({ ...empresa, file: imagem });
    const imageData = new FormData();

    imageData.append("file", imagem);
    imageData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

    await api
      .post("/upload", imageData)
      .then((res) => {
        const logotipo = res.data.url;
        swal("Imagem enviada com sucesso", "", "success");
        logo.current["valor"] = logotipo;
      })
      .catch((err) => {
        swal("Ops!, Ocorreu um erro durante o envio da imagem", "", "error");
      });
  };

  const handleInfo = async (props) => {
    if (props.file == "") {
      setEmpresa({
        ...empresa,
        nome: props.nome,
        url: props.url,
        logo: "não tem logo",
      });
    } else {
      await uploadImage(props.file);
      setEmpresa({
        ...empresa,
        nome: props.nome,
        url: props.url,
        file: props.file,
        logo: logo.current.valor,
      });
    }
  };

  const handleEmpresa = async () => {
    const empresaValidation = yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome da empresa")
        .required("Necessário que informe o nome da empresa"),
      logo: yup
        .string("Necessário que envie a logo do empresa")
        .required("Necessário que envie a logo do empresa"),
      url: yup
        .string("Necessário que informe url do portal da empresa")
        .required("Necessário que informe url do portal da empresa"),
    });

    try {
      await empresaValidation.validate(empresa, { abortEarly: true });

      await api
        .post(`/admin/empresas`, empresa)
        .then(async (res) => {
          let array = {
            local: "empresas",
            texto: `criou a empresa de id=${res.data.empresa.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(array) });
          swal("Empresa criada com sucesso", "", "success");
          setIdEmpresa(res.data.empresa.id);
        })
        .catch((err) => {
          swal("Não foi possível criar a empresa", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Empresa</Title>
          <Segment>
            <Menu pointing>
              <Menu.Item
                name="Informacoes"
                active={valorName === "Informacoes"}
                onClick={(e) => setValorName(e.target.text)}
              />

              <Menu.Menu position="right">
                <AlignDiv>
                  <h3>Criação de {valorName}</h3>
                </AlignDiv>
              </Menu.Menu>
            </Menu>
            <div>
              {
                {
                  Informacoes: (
                    <Informacoes
                      handleInfo={handleInfo}
                      valor={empresa}
                      handleEmpresa={handleEmpresa}
                    />
                  ),
                  // Planos: <Planos handlePlanos={handlePlanos} valor={planos} />,
                }[valorName]
              }
            </div>
            <Field>
              <Button type="submit" onClick={handleEmpresa}>
                <Icon name="save" />
                Salvar
              </Button>
            </Field>
          </Segment>
        </Content>
      </Container>
    </>
  );
};

export default CriarEmpresas;
